import React from 'react';
import styled from 'styled-components';

const Input = styled.textarea`
  width: 100%;
  height: 100px;
  min-height: 42px;
  border: 1px solid ${({ theme }) => theme.themeColors.border};
  border-radius: 4px;
  padding: 8px;
  font-size: 14px;
  line-height: 18px;
  color: ${({ theme }) => theme.themeColors.text};
  resize: vertical;
`;

export const QuestionInput = ({ onChange, value }) => {
  return <Input type="text" id="question-input" s onChange={onChange} value={value} />;
};
